module.exports = __webpack_public_path__ + "assets/img/discuss-bg1.651956da.png";